module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("Coodenadas del centro")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Coordenadas",
      "type": "String"
    },
    model: {
      value: (_vm.coordinates),
      callback: function($$v) {
        _vm.coordinates = $$v
      },
      expression: "coordinates"
    }
  }), _vm._v(" "), (_vm.showError) ? _c('p', {
    staticClass: "error-text"
  }, [_vm._v("Por favor separar coordenadas con \",\"")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onCancel();
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc8d375","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/new/CoordinatesInputForm.vue
// module id = 773
// module chunks = 25